import { AbstractModel } from '@/models/abstractModel';
import { useCountryDictionary, useProxyDictionary } from '@/stores';
import type { IMonitoringProxy } from '@/types';

export class MonitoringProxy extends AbstractModel {
    public allocatedCount: number;
    public countryId: number | null;
    public mostAllocated: number;
    public mostAllocatedProxyId: number;
    public mostAllocatedSecond: number;
    public mostAllocatedSecondProxyId: number;
    public mostAllocatedThird: number;
    public mostAllocatedThirdProxyId: number;
    public totalProxyCount: number;

    constructor(data: IMonitoringProxy) {
        super();
        this.countryId = data.country_id;
        this.totalProxyCount = data.total_proxy_count;
        this.allocatedCount = data.allocated_count;
        this.mostAllocated = data.most_allocated;
        this.mostAllocatedProxyId = data.most_allocated_proxy_id;
        this.mostAllocatedSecond = data.most_allocated_second;
        this.mostAllocatedSecondProxyId = data.most_allocated_second_proxy_id;
        this.mostAllocatedThird = data.most_allocated_third;
        this.mostAllocatedThirdProxyId = data.most_allocated_third_proxy_id;
    }

    get allocatedClass(): string {
        return this.countryId === null ? 'font-weight-bold' : '';
    }

    get freeClass(): string {
        const free = this.freeCount;
        const baseClass = this.countryId === null ? 'font-weight-bold' : '';
        return free > 0 ? `${baseClass} text-tbRed` : `${baseClass} text-tbGreen`;
    }

    get freeCount(): number {
        return this.totalProxyCount - this.allocatedCount;
    }

    get mostAllocatedDisplay(): string {
        if (!this.mostAllocated) return '';
        try {
            const proxyDictionary = useProxyDictionary();
            const name = proxyDictionary.nameById(this.mostAllocatedProxyId) || '';
            return name ? `${name} (${this.mostAllocated})` : '';
        } catch {
            return '';
        }
    }

    get proxiesClass(): string {
        return this.countryId === null ? 'text-tbGreen' : '';
    }

    get proxyLocationDisplay(): string {
        if (this.countryId === null) return '';
        try {
            const countryDictionary = useCountryDictionary();
            return countryDictionary.itemById(this.countryId)?.iso3?.toUpperCase() || '';
        } catch {
            return '';
        }
    }

    get secondMostAllocatedDisplay(): string {
        if (!this.mostAllocatedSecond) return '';
        try {
            const proxyDictionary = useProxyDictionary();
            const name = proxyDictionary.nameById(this.mostAllocatedSecondProxyId) || '';
            return name ? `${name} (${this.mostAllocatedSecond})` : '';
        } catch {
            return '';
        }
    }

    get statusClass(): string {
        return this.totalProxyCount - this.allocatedCount > 0 ? 'status-yellow' : 'status-green';
    }

    get thirdMostAllocatedDisplay(): string {
        if (!this.mostAllocatedThird) return '';
        try {
            const proxyDictionary = useProxyDictionary();
            const name = proxyDictionary.nameById(this.mostAllocatedThirdProxyId) || '';
            return name ? `${name} (${this.mostAllocatedThird})` : '';
        } catch {
            return '';
        }
    }
}
